import React from "react";
import FfrStatus from "../components/FfrStatus/FfrStatus";
import { FfrStatusService } from "../services/service.ffrStatus";
import { toast } from "react-toastify";
import config from "../config/config";

class FfrStatusContainer extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            showSpinner: false,
            ffrNumber: "",
            statusData: null,
            sourcePayload: null,
            processedPayload: null,
            errorMessage: null,
            logsLoading: false
        };
    }

    handleFfrNumberChange = (value) => {
        this.setState({ 
            ffrNumber: value,
            errorMessage: null
        });
    };

    handleSearch = async () => {
        const { ffrNumber } = this.state;
        const { dcValue } = this.props;
        
        if (!ffrNumber || ffrNumber.trim().length === 0) {
            toast.error("Please enter an FFR Number");
            return;
        }

        this.setState({ 
            showSpinner: true, 
            errorMessage: null,
            statusData: null,
            sourcePayload: null,
            processedPayload: null
        });

        try {
            // Fetch FFR Status
            const statusResponse = await FfrStatusService.getFfrStatus(ffrNumber.trim(), dcValue);
            
            if (statusResponse.status === 200 && statusResponse.data) {
                this.setState({ statusData: statusResponse.data });
                
                // Fetch Source Payload if available
                if (statusResponse.data.sourceFile?.available) {
                    this.fetchPayload('source');
                }
                
                // Fetch Processed Payload if available
                if (statusResponse.data.processedFile?.available) {
                    this.fetchPayload('processed');
                }
                
                toast.success(`FFR Status loaded for ${ffrNumber}`);
            } else {
                this.setState({ 
                    errorMessage: "No data found for the provided FFR Number"
                });
                toast.error("No data found for the provided FFR Number");
            }
        } catch (error) {
            const errorMsg = error.response?.data?.message ||
                           error.message || 
                           "Failed to fetch FFR status. Please try again.";
            this.setState({ 
                errorMessage: errorMsg
            });
            toast.error(errorMsg);
        } finally {
            this.setState({ showSpinner: false });
        }
    };

    fetchPayload = async (type) => {
        const { ffrNumber } = this.state;
        const { dcValue } = this.props;
        
        try {

            const response = await FfrStatusService.downloadFfrPayload(ffrNumber.trim(), dcValue, type);
            if (response.status === 200 && response.data) {
                // With mode=content, the API returns the payload directly in response.data

                if (type === 'source') {
                    this.setState({ sourcePayload: response.data });
                } else if (type === 'processed') {
                    this.setState({ processedPayload: response.data });
                }
                
                toast.success(`${type.charAt(0).toUpperCase() + type.slice(1)} payload loaded`);
            } else {
                toast.warn(`${type} payload not available`);
                
                const errorData = { error: `No data available (status: ${response.status})` };
                if (type === 'source') {
                    this.setState({ sourcePayload: errorData });
                } else {
                    this.setState({ processedPayload: errorData });
                }
            }
        } catch (error) {
            const errorMsg = error.response?.data?.message ||
                           error.response?.statusText ||
                           error.message || 
                           'Unknown error';
            
            toast.error(`Could not load ${type} payload: ${errorMsg}`);
            
            // Set error state for UI display
            const errorData = { error: `Failed to load: ${errorMsg}` };
            if (type === 'source') {
                this.setState({ sourcePayload: errorData });
            } else {
                this.setState({ processedPayload: errorData });
            }
        }
    };

    handleViewLogs = async () => {
        const { statusData } = this.state;

        if (!statusData?.ffrNumber) return;

        this.setState({ logsLoading: true });
        try {
            const response = await FfrStatusService.getFfrErrorLogsUrl(
                statusData.ffrNumber,
                config.splunkEnv,
                config.splunkGeo
            );
            if (response.data?.splunkUrl) {
                window.open(response.data.splunkUrl, '_blank');
            } else {
                toast.error("Could not generate Splunk link. Please try again.");
            }
        } catch (error) {
            toast.error("Failed to generate Splunk logs link. Please try again.");
        } finally {
            this.setState({ logsLoading: false });
        }
    };

    handleDownloadSource = () => {
        const { sourcePayload, ffrNumber } = this.state;
        if (sourcePayload) {
            this.downloadJSON(sourcePayload, `${ffrNumber}_source.json`);
        }
    };

    handleDownloadProcessed = () => {
        const { processedPayload, ffrNumber } = this.state;
        if (processedPayload) {
            this.downloadJSON(processedPayload, `${ffrNumber}_processed.json`);
        }
    };

    downloadJSON = (data, filename) => {
        const blob = new Blob([JSON.stringify(data, null, 2)], { type: 'application/json' });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
        toast.success(`Downloaded ${filename}`);
    };

    render() {
        return (
            <FfrStatus
                showSpinner={this.state.showSpinner}
                ffrNumber={this.state.ffrNumber}
                onFfrNumberChange={this.handleFfrNumberChange}
                handleSearch={this.handleSearch}
                statusData={this.state.statusData}
                sourcePayload={this.state.sourcePayload}
                processedPayload={this.state.processedPayload}
                errorMessage={this.state.errorMessage}
                handleDownloadSource={this.handleDownloadSource}
                handleDownloadProcessed={this.handleDownloadProcessed}
                handleViewLogs={this.handleViewLogs}
                logsLoading={this.state.logsLoading}
                dcValue={this.props.dcValue}
            />
        );
    }
}

export default FfrStatusContainer;
